import { can } from './permissions'
import { MENU_MODULES } from './menu'
const rules: { prefix: string; permissions: readonly string[]; home?: string }[] = [
  ...MENU_MODULES.map(item => ({prefix:item.to,permissions:item.permissions})),
  { prefix:'/kb', permissions:['kb.ask'], home:'/library' },
  { prefix:'/revisions/', permissions:['revision.diff_process'], home:'/library' },
  { prefix:'/assets/', permissions:['revision.diff_process'], home:'/library' },
]
export function canAccessPage(roles: string[], pathname: string): boolean {
  const rule=rules.find(item=>pathname===item.prefix || pathname.startsWith(item.prefix.endsWith('/')?item.prefix:item.prefix+'/'))
  return Boolean(rule?.permissions.some(permission=>can(roles,permission)))
}
export function homeFor(roles: string[]): string {
  return rules.find(item=>!item.home && item.permissions.some(permission=>can(roles,permission)))?.prefix ?? '/no-access'
}

/** Preserve only local business routes; authorization is still checked after loading the current policy. */
function businessReturnTo(value: string): string | null {
  if (!value.startsWith('/') || value.startsWith('//') || /[\\\s\u0000-\u001f\u007f]/.test(value)) return null
  try {
    const url = new URL(value, 'https://workspace.invalid')
    const path = decodeURIComponent(url.pathname)
    if (url.origin !== 'https://workspace.invalid' || path.startsWith('//') || path.includes('\\')) return null
    if (!rules.some(rule => url.pathname === rule.prefix || url.pathname.startsWith(rule.prefix.endsWith('/') ? rule.prefix : rule.prefix + '/'))) return null
    return url.pathname + url.search + url.hash
  } catch { return null }
}

export function loginUrl(requested: string): string {
  const target = businessReturnTo(requested)
  return target ? '/login?' + new URLSearchParams({ returnTo: target }).toString() : '/login'
}

export function loginReturnTo(search: string): string | null {
  return businessReturnTo(new URLSearchParams(search).get('returnTo') ?? '')
}
